var map = {
	"./az.json": [
		1205,
		110
	],
	"./en.json": [
		1206,
		111
	],
	"./ru.json": [
		1207,
		112
	],
	"./tr.json": [
		1208,
		113
	],
	"./widgets/az.json": [
		893,
		8
	],
	"./widgets/en.json": [
		894,
		9
	],
	"./widgets/ru.json": [
		895,
		10
	],
	"./widgets/tr.json": [
		896,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 789;
module.exports = webpackAsyncContext;